import {Mapper} from '@s-ui/domain'

export class HttpMakeModelAdsListingToAdsListValueObjectMapper extends Mapper {
  constructor({httpSearchResultsResponseToAdsListValueObjectMapper, wdylAdsValueObjectFactory}) {
    super()
    this._httpSearchResultsResponseToAdsListValueObjectMapper = httpSearchResultsResponseToAdsListValueObjectMapper
    this._wdylAdsValueObjectFactory = wdylAdsValueObjectFactory
  }

  map = async ({vn, renting} = {}) => {
    const newVehiclesValueObject = this._httpSearchResultsResponseToAdsListValueObjectMapper.map(vn)

    const rentingVehiclesValueObject = this._httpSearchResultsResponseToAdsListValueObjectMapper.map(renting)

    return this._wdylAdsValueObjectFactory({
      newVehiclesValueObject,
      rentingVehiclesValueObject
    })
  }
}
